import { Box, Text } from '@chakra-ui/react'
import { FieldMapValue } from '@hb/shared'
import { SectionLabel } from '../../SectionLabel'

export const ExamNotesView = ({ data }: { data: FieldMapValue }) => {
  const notes = data?.notes as string | undefined
  return (
    <Box w="100%">
      <SectionLabel>Notes</SectionLabel>
      {notes ? (
        <Text whiteSpace="pre-wrap" fontSize="sm">
          {notes}
        </Text>
      ) : (
        <Text fontStyle="italic" color="gray.500" fontSize="sm">
          No notes recorded
        </Text>
      )}
    </Box>
  )
}
